import { datePickerSharedProps as e, selectionModeWithDefault as o } from "./index935.js";
import { buildProps as t } from "./index601.js";
const s = t({
  ...e,
  showWeekNumber: Boolean,
  selectionMode: o("date")
}), i = ["changerange", "pick", "select"];
export {
  i as basicDateTableEmits,
  s as basicDateTableProps
};
